import _ from 'lodash';
import update from 'react-addons-update';
import {
	GEOCODE_STARTED, GEOCODE_FAILED, GEOCODE_COMPLETED
} from '../actions/tryActions';

let initialState = {
	isGeocoding: false,
	errorMessage: null,
	geocodingResult: null,
	query: null,
	direction: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case GEOCODE_STARTED:
      return update(state, {
        isGeocoding: { $set: true },
        errorMessage: { $set: null },
        geocodingResult: { $set: null },
        query: { $set: action.query },
        direction: { $set: action.direction },
      });

    case GEOCODE_FAILED:
      return update(state, {
        isGeocoding: { $set: false },
        errorMessage: { $set: action.errorMessage },
        geocodingResult: { $set: null },
        query: { $set: null },
        direction: { $set: null },
      });

    case GEOCODE_COMPLETED:
      return update(state, {
        isGeocoding: { $set: false },
        errorMessage: { $set: null },
        geocodingResult: { $set: action.response }
      });

    default:
      return state;
  }
}

export default reducer;
